import {
  init as SentryInit,
  captureConsoleIntegration,
  reactRouterV6BrowserTracingIntegration,
  replayIntegration,
} from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

const env = import.meta.env.VITE_ENV;
const sentryDSN = import.meta.env.VITE_SENTRY_DSN;

if (sentryDSN && env !== "local") {
  SentryInit({
    dsn: sentryDSN,
    environment: env,

    // Performance Monitoring
    tracesSampleRate: ["prod", "pre-prod"].includes(env) ? 0.2 : 0.1, // pre-prod for perf tests

    // We have only 50 replays per month, so we focus on prod env only
    replaysSessionSampleRate: 0, // focus only on error replays
    replaysOnErrorSampleRate: env === "prod" ? 1.0 : 0,

    // Increase the depth of the stack trace to capture - default is 3
    normalizeDepth: 8,

    integrations: [
      captureConsoleIntegration({
        levels: ["error", "warning"],
      }),
      // React router library mode integration with all hooks enabled - see docs for details
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration({
        // show all data in the replays
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [
          // only capture Mine Assure API calls, no sensitive information there
          import.meta.env.VITE_API_URL,
        ],
        networkRequestHeaders: ["X-Tenant-Id"], // Additional headers
      }),
    ],
  });
}
